<div class="system-container">
  <form #form="ngForm" class="form-validate" (ngSubmit)="save()" autocomplete="off">
    <div class="row">
      <div class="card custom-box my-3 border-0">
        <div class="card-body">
          <!-- ส่วนโลโก้และชื่อระบบ -->
          <div class="row mt-3">
            <div class="text-center">
              <img src="assets/images/logo_acfs.png" class="img-card">
            </div>
          </div>
          <div class="row mt-3">
            <div class="text-center">
              <h2 class="system-title">
                ระบบตามสอบสินค้าเกษตรบนระบบคลาวด์
                <br>
                (QR Trace on Cloud)
              </h2>
            </div>
          </div>

          <!-- ส่วนชื่อ -->
          <div class="row mt-4 mb-3">
            <div class="col-md-5 col-12 text-md-end text-start mb-md-0 mb-1">
              <label class="ui-require">ชื่อ / Name</label>
            </div>
            <div class="col-md-7 col-12">
              <label>{{ thaiD.given_name }}</label>
            </div>
          </div>

          <!-- ส่วนนามสกุล -->
          <div class="row mb-3">
            <div class="col-md-5 col-12 text-md-end text-start mb-md-0 mb-1">
              <label class="ui-require">นามสกุล / Surname</label>
            </div>
            <div class="col-md-7 col-12">
              <label>{{ thaiD.family_name }}</label>
            </div>
          </div>

          <!-- ส่วนเบอร์โทรศัพท์ -->
          <div class="row mb-3">
            <div class="col-md-5 col-12 text-md-end text-start mb-md-0 mb-1">
              <label class="ui-require">เบอร์ติดต่อ / Telephone</label>
            </div>
            <div class="col-md-7 col-12">
              <div class="input-container">
                <input #mobile="ngModel" type="text" id="mobile" name="mobile" [pattern]="telephoneNumber"
                       [(ngModel)]="param.mobile" class="form-control" required>
                @if (mobile.invalid && (mobile.dirty || mobile.touched)) {
                  <div class="invalid-feedback d-block">
                    @if (mobile.errors?.['required']) {
                      <div>กรุณากรอกเบอร์มือถือ</div>
                    }
                    @if (mobile.errors?.['pattern']) {
                      <div>กรุณากรอกเบอร์มือถือ 10 หลัก</div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>

          <!-- ส่วนอีเมล (แสดงเมื่อไม่มี registerUuid) -->
          @if (!thaiD.registerUuid) {
            <div class="row mb-3">
              <div class="col-md-5 col-12 text-md-end text-start mb-md-0 mb-1">
                <label class="ui-require">e-Mail</label>
              </div>
              <div class="col-md-7 col-12">
                <div class="input-container">
                  <input #email="ngModel" type="text" id="email" name="email" [pattern]="emailPattern"
                         [(ngModel)]="param.email" class="form-control" required>
                  @if (email.invalid && (email.dirty || email.touched)) {
                    <div class="invalid-feedback d-block">
                      @if (email.errors?.['required']) {
                        <div>กรุณากรอกอีเมล</div>
                      }
                      @if (email.errors?.['pattern']) {
                        <div>อีเมลไม่ถูกต้อง</div>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          }
          <!-- Decoy fields -->
          <input type="text" name="fakeuser" style="display:none">
          <input type="password" name="fakepass" style="display:none">
          <!-- ส่วนชื่อผู้ใช้งาน -->
          <div class="row mb-3">
            <div class="col-md-5 col-12 text-md-end text-start mb-md-0 mb-1">
              <label class="ui-require">ชื่อผู้ใช้งาน / Username</label>
            </div>
            <div class="col-md-7 col-12">
              <div class="input-container">
                <input #username="ngModel" type="text" id="username" name="username" [(ngModel)]="param.username"
                       [pattern]="lotNoPattern"
                       autocomplete="off"
                       class="form-control" required>
                @if (username.invalid && (username.dirty || username.touched)) {
                  <div class="invalid-feedback d-block">
                    @if (username.errors?.['required']) {
                      <div>กรุณากรอกชื่อผู้ใช้งาน</div>
                    }
                    @if (username.errors?.['pattern']) {
                      <div>*ชื่อผู้ใช้งานต้องประกอบไปด้วยตัวอักษรภาษาอังกฤษ ตัวเลข หรือเครื่องหมาย _ (ขีดล่าง) - (ขีดกลาง) . (จุด) เท่านั้น</div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>

          <!-- ส่วนรหัสผ่าน -->
          <div class="row mb-3">
            <div class="col-md-5 col-12 text-md-end text-start mb-md-0 mb-1">
              <label class="ui-require">ระบุรหัสผ่าน / Password</label>
            </div>
            <div class="col-md-7 col-12">
              <div class="password-container">
                <!-- ช่องป้อนรหัสผ่าน -->
                <div class="password-input-container">
                  <input id="password" name="password"
                         autocomplete="new-password"
                         #passwordField="ngModel"
                         englishDigitsOnly
                         [(ngModel)]="param.password"
                         [type]="visibleConfirm ? 'text' : 'password'"
                         (input)="onPasswordInput()"
                         class="form-control ps-5"
                         [ngClass]="{'is-invalid': passwordField.invalid && (passwordField.dirty || passwordField.touched)}"
                         required>
                  <span class="password-icon lock-icon">
                  <i class="bi bi-lock-fill"></i>
                </span>
                  <span class="password-icon eye-icon" (click)="viewPassword('confirm')">
                  <i [ngClass]="visibleConfirm ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
                </span>
                  @if (passwordField.invalid && (passwordField.dirty || passwordField.touched)) {
                    <div class="invalid-feedback d-block">
                      @if (passwordField.errors?.['required']) {
                        กรุณากรอกรหัสผ่าน
                      }
                      @if (passwordField.errors?.['pattern']) {
                        กรุณาตรวจสอบรหัสผ่าน
                      }
                    </div>
                  }
                </div>

                <!-- เงื่อนไขรหัสผ่าน -->
                <div class="password-requirements p-3 mt-3">
                  <div class="d-flex align-items-center mb-2">
                    <i class="bi bi-shield-lock me-2"></i>
                    <span>รหัสผ่านต้องประกอบด้วย:</span>
                  </div>
                  <div class="ms-1">
                    <div class="form-check mb-2">
                      <input class="form-check-input" type="radio" disabled [checked]="passwordValidations.minLength">
                      <label class="form-check-label" [ngClass]="passwordValidations.minLength ? 'color-condition-text' : ''">
                        มีความยาวอย่างน้อย 6 ตัวอักษร
                      </label>
                    </div>
                    <div class="form-check mb-2">
                      <input class="form-check-input" type="radio" disabled [checked]="passwordValidations.hasUpperCase || passwordValidations.hasLowerCase">
                      <label class="form-check-label" [ngClass]="passwordValidations.hasUpperCase || passwordValidations.hasLowerCase ? 'color-condition-text' : ''">
                        มีตัวอักษรพิมพ์เล็ก หรือ ตัวอักษรพิมพ์ใหญ่อย่างน้อย 1 ตัว
                      </label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" type="radio" disabled [checked]="passwordValidations.hasDigit">
                      <label class="form-check-label" [ngClass]="passwordValidations.hasDigit ? 'color-condition-text' : ''">
                        มีตัวเลขอย่างน้อย 1 ตัว
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- ส่วนยืนยันรหัสผ่าน -->
          <div class="row mb-4">
            <div class="col-md-5 col-12 text-md-end text-start mb-md-0 mb-1">
              <label class="ui-require">ระบุรหัสผ่านอีกครั้ง / Confirm Password</label>
            </div>
            <div class="col-md-7 col-12">
              <div class="password-container">
                <div class="password-input-container">
                  <input id="confirm-password" name="confirmPassword"
                         #confirmPasswordField="ngModel"
                         englishDigitsOnly
                         [(ngModel)]="confirmPassword"
                         [type]="visibleReConfirm ? 'text' : 'password'"
                         class="form-control ps-5"
                         [ngClass]="{'is-invalid': confirmPasswordField.invalid && (confirmPasswordField.dirty || confirmPasswordField.touched) || (param.password && confirmPassword && param.password !== confirmPassword)}"
                         required>
                  <span class="password-icon lock-icon">
                  <i class="bi bi-lock-fill"></i>
                </span>
                  <span class="password-icon eye-icon" (click)="viewPassword('reconfirm')">
                  <i [ngClass]="visibleReConfirm ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
                </span>
                  @if ((confirmPasswordField.dirty || confirmPasswordField.touched)) {
                    @if (confirmPasswordField.errors?.['required']) {
                      <div class="invalid-feedback d-block">
                        กรุณายืนยันรหัสผ่าน
                      </div>
                    } @else if (param.password && confirmPassword && param.password !== confirmPassword) {
                      <div class="invalid-feedback d-block">
                        รหัสผ่านไม่ตรงกัน
                      </div>
                    } @else if (param.password && confirmPassword && param.password === confirmPassword) {
                      <div class="valid-feedback d-block">
                        <i class="bi bi-check-circle-fill me-1"></i>รหัสผ่านตรงกัน
                      </div>
                    }
                  }
                </div>
              </div>
            </div>
          </div>

          <!-- ปุ่มยืนยัน -->
          <div class="row mb-3 mt-1">
            <div class="col-md-5 col-12"></div>
            <div class="col-md-7 col-12 text-center text-md-start">
              <button type="submit"
                      [disabled]="form.invalid || !passwordValid || (param.password !== confirmPassword)"
                      class="btn btn-custom btn-custom-theme btn-thaid">
                ยืนยันการลงทะเบียน
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
